export const ADD_HAZARD_FILE = "ADD_HAZARD_FILE";
export const HIDE_HAZARD_FILE = "HIDE_HAZARD_FILE";
export const UPDATE_HAZARD_PROFILE_SUMMARY = "UPDATE_HAZARD_PROFILE_SUMMARY";
export const UPDATE_HAZARD_PROFILE_SUMMARY_STARTED =
  "UPDATE_HAZARD_PROFILE_SUMMARY_STARTED";
export const UPDATE_HAZARD_PROFILE_SUMMARY_SUCCEEDED =
  "UPDATE_HAZARD_PROFILE_SUMMARY_SUCCEEDED";
export const UPDATE_HAZARD_PROFILE_SUMMARY_FAILED =
  "UPDATE_HAZARD_PROFILE_SUMMARY_FAILED";
